import { connect } from 'react-redux';
import { getFormValues, reset, destroy, isDirty } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import AddBinLocationDialog from './AddBinLocationDialog';
const FORM_NAME = 'AddBinLocationDialog';
const mapStateToProps = (state: IApplicationState) => ({
    dirty: isDirty(FORM_NAME)(state),
    formValues: getFormValues(FORM_NAME)(state),
});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
        destroyForm: () => destroy(FORM_NAME),
    },
    dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AddBinLocationDialog);
